import httpClient from "./httpClient";
import { VacancyType } from "../types/listings";

const END_POINT = "/vacancytypes";

const putVacancyType = async (
	id: number,
	vacancy: VacancyType
): Promise<VacancyType | undefined> => {
	const response = await httpClient.put(`${END_POINT}/${id}`, vacancy);
	return response.data as VacancyType;
};

export { putVacancyType };
